import React from 'react';
import TotalSummaryMetricsCard from './TotalSummaryMetricsCard';
import PCMetricsCard from './PCMetricsCard';
import MobileMetricsCard from './MobileMetricsCard';
import { AnalysisSummaryTypeTab } from '../types';

export default function LeftMetricsCard({
  value,
  gameInfo,
  filter,
  wholeGameInfo,
}: {
  value: AnalysisSummaryTypeTab;
  gameInfo: any;
  filter: any;
  wholeGameInfo: any;
}) {
  if (value === 'total' || value === 'community') {
    return (
      <TotalSummaryMetricsCard
        gameInfo={gameInfo}
        filter={filter}
        tab={value}
      />
    );
  }

  if (value === 'app store' || value === 'google play') {
    return (
      <MobileMetricsCard gameInfo={gameInfo} filter={filter} tab={value} />
    );
  }

  if (value === 'steam') {
    return (
      <PCMetricsCard
        gameInfo={gameInfo}
        filter={filter}
        tab={value}
        wholeGameInfo={wholeGameInfo}
      ></PCMetricsCard>
    );
  }
}
